import styles from './Profile.module.scss'
import {Paper} from 'common/components'
import {ProfileUpdates, ProfileUser} from '.'

export default function Profile() {
  return (
    <div className={styles.root}>
      <Paper>
        <ProfileUser />
        <ProfileUpdates />
      </Paper>
      {/* <Paper>
        <div></div>
        <ProfileStatistic />
      </Paper> */}
    </div>
  )
}
